import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, TrafficCone, Shield, Clock, MessageCircleHeart } from 'lucide-react';
export function WhatYouGetSection() {
  const items = [{
    icon: <BookOpen className="w-6 h-6" data-id="element-149" />,
    title: 'La Guía Digital Completa',
    desc: 'El paso a paso para salir de la trampa del "compañero de piso".'
  }, {
    icon: <TrafficCone className="w-6 h-6" data-id="element-150" />,
    title: 'El Sistema del Semáforo',
    desc: 'Una forma honesta de comunicar tu energía sexual sin herir al otro.'
  }, {
    icon: <Shield className="w-6 h-6" data-id="element-151" />,
    title: 'Protocolo de "Habitación de Adultos"',
    desc: 'Cómo blindar tu santuario contra el caos infantil.'
  }, {
    icon: <Clock className="w-6 h-6" data-id="element-152" />,
    title: 'Ejercicios de 180 Segundos',
    desc: 'Técnicas táctiles de alta eficiencia para padres agotados.'
  }, {
    icon: <MessageCircleHeart className="w-6 h-6" data-id="element-153" />,
    title: 'Guion de Comunicación No-Acusatoria',
    desc: 'Cómo decir lo que necesitas sin empezar una pelea.'
  }];
  return <section className="px-6 py-10" data-id="element-154">
      <div className="max-w-5xl mx-auto" data-id="element-155">
        <motion.h3 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="font-serif text-3xl md:text-5xl text-center text-brand-light mb-8" data-id="element-156">
          Lo que <span className="text-brand-accent italic" data-id="element-157">recibirás</span>
        </motion.h3>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-158">
          {items.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-brand-light/5 border border-brand-light/10 p-8 rounded-2xl hover:bg-brand-light/10 transition-colors" data-id="element-159">
              <div className="w-12 h-12 bg-brand-accent/10 rounded-xl flex items-center justify-center text-brand-accent mb-6" data-id="element-160">
                {item.icon}
              </div>
              <h4 className="text-xl font-medium text-brand-light mb-3" data-id="element-161">
                {item.title}
              </h4>
              <p className="text-brand-light/70 font-light leading-relaxed" data-id="element-162">
                {item.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}